/**
 * Находит элементы первого массива, которых нет во втором. Без дубликатов.
 *
 * @param first Первый массив
 * @param second Второй массив
 * @typeParam T Тип элементов в массиве
 * @returns Разность первого и второго массивов
 *
 * @example
 * ```typescript
 * import { difference } from '@direct-frontend/stdlib';
 *
 * difference([1, 2, 3, 4, 5], [2, 3, 7, 8]);
 * // '[1,4,5]'
 * ```
 */
export function difference(first, second) {
    const setFirst = new Set(first);
    const setSecond = new Set(second);
    return [...setFirst].filter(x => !setSecond.has(x));
}
